<template>
<div>
    <header>
        <a href="#" @click.prevent="goBack" class="back"></a>
        <h1>Profil bearbeiten</h1>
    </header>

    <section>
        <div class="item">
            <dp :who="user" />
            <h3>{{user | name}}</h3>
            <div class="clear"></div>
        </div>
    </section>

    <section>
        <div class="form-group">
            <input type="file" accept="image/jpeg,image/jpg,image/png,image/bmp,image/gif" id="photo-upload">
            <input type="submit" value="Hochladen" class="btn btn-secondary" @click.prevent="uploadPhoto()">
        </div>
        <custom-form :fields="[ { name: 'username', title: 'Benutzername', type: 'text', disabled: true }, 
                                'firstname', 'lastname', 'motto', 'racket',
                                'school', 'year', 'yob', 'sex', 'city', 'handedness' ]"
                     v-model="me"
                     submitLabel="Speichern" 
                     url="users/me/update"
                     @submitted="updated" />

    </section>

    <section>
        <router-link to="change-password" class="btn btn-secondary">
            Passwort ändern
        </router-link>
    </section>
</div>
</template>

<script>
import _ from 'underscore'
import customForm from 'components/custom-form.vue'
import dp from 'components/dp.vue'
import base from 'base.vue'

export default {
    mixins: [ base ],
    components: { customForm, dp },
    data () {
        return {
            me: { city: { }, school: { } }
        }
    },
    computed: {
        lastYear () {
            const now = new Date
            if (now > new Date(now.getFullYear(), 8, 1)) {
                return now.getFullYear()
            } else {
                return now.getFullYear() - 1
            }
        }
    },
    methods: {
        fetchData () {
            const that = this
            
            return this.$api.get('users/' + window.store.state.user.id + '/profile')
            .then(response => {
                that.me = response.data
                window.store.commit('update', that.me)
            })
        },
        uploadPhoto () {
            const that = this
            const formData = new FormData()
            formData.append('api_token', window.store.state.user.api_token)
            formData.append('photo', document.getElementById('photo-upload').files[0])

            this.$api.post('users/me/upload-photo', formData)
            .then(response => {
                window.store.commit('update', response.data)

                that.$el.querySelector('.dp').src = `/storage/photos/${response.data.dp}?${new Date().getTime()}`
            })
        },
        updated () {
            window.store.commit('update', this.me)
            window.router.back()
        }
    }
}
</script>



// WEBPACK FOOTER //
// profile-edit.vue?715d922b